
import React, {Component} from 'react';
import {IoLocation} from "react-icons/io5";

export default class LocationMarker extends Component {

  render() {
    return (
      <IoLocation color="red" size="2.5em" />
    );
  }
}